<mat-card-content [formGroup]="mainForm">
    <h1 class="tw-flex tw-flex-row tw-flex-wrap tw-justify-between">
      <span class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
          支払方法変更
      </span>
      <mat-icon (click)="onClickIcon()">info_outline</mat-icon>
    </h1>
    <div fxLayout="row wrap" fxLayoutAlign="start center">
      <mat-form-field appearance="fill" class="input-form" fxFlex="30" fxFlex.lt-md="100">
        <mat-label>支払契約番号</mat-label>
        <input matInput
          formControlName="claimCtrNo"
          #claimCtrNo
          class="font-color-display-only"
          readonly="true"
        />
      </mat-form-field>
    </div>
    <div fxLayout="row wrap">
      <mat-form-field appearance="fill" class="input-form" fxFlex="30" fxFlex.lt-md="100">
        <mat-label>お客さま氏名</mat-label>
        <input matInput
          formControlName="visitName"
          #visitName
          class="font-color-display-only"
          readonly="true"
        />
      </mat-form-field>
      <mat-form-field appearance="fill" class="input-form" fxFlex="30" fxFlex.lt-md="100">
        <mat-label>住所</mat-label>
        <input matInput
          formControlName="addr"
          #visitName
          class="font-color-display-only"
          readonly="true"
        />
      </mat-form-field>
    </div>
  </mat-card-content>